import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import type { PlumaTheme, PartialPlumaTheme } from '@/css/themes/pluma-theme';
interface ThemeContainerSignature {
    Element: HTMLDivElement;
    Args: {
        theme?: PlumaTheme | PartialPlumaTheme | null;
    };
    Blocks: {
        default: [];
    };
}
export default class ThemeContainer extends Component<ThemeContainerSignature> {
    get themeClassName() {
        return this.args.theme?.className ?? null;
    }
    static{
        template(`<div class={{this.themeClassName}} ...attributes>{{yield}}</div>`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
